import React from 'react';
import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Coach Active Tools Page
 * Shows the coach's active AI tools from the marketplace
 */
export default function CoachAiTools() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <RoleActiveTools
        role="coach"
        title="Your AI Tools"
        description="Launch your active AI and SmartBlock tools for practice planning, recruiting, and athlete performance tracking."
        marketplacePath="/portal/locker/ai-marketplace"
        trackerBasePath="/portal/locker/tracker"
        showComingSoon={true}
      />
    </div>
  );
}
